import { styled } from "@mui/material/styles";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar";

const DashboardLayoutRoot = styled("div")(() => ({
  backgroundColor: "#d8d8d8",
  display: "flex",
  height: "100%",
  overflow: "hidden",
  width: "100%",
  position: "relative"
}));

const DashboardLayoutWrapper = styled("div")(() => ({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
  paddingTop: 64,
}));

const DashboardLayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
});

const DashboardLayoutContent = styled("div")({
  flex: "1 1 auto",
  height: "100%",
  overflow: "auto",
});
//DEPOIS FAZER IMPORT O userRole
const DashboardLayout = () => {
  const navigate = useNavigate();

  const toGo = (path) => navigate(path, { replace: true });

  return (
    <DashboardLayoutRoot>
      {/* passar userRole na navbar */}
      <DashboardNavbar to={toGo} />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
            {/* <SidebarPhoneForm open={openDrawer} onClose={toggleDrawer}/>
            {
              !openDrawer && <SidebarPhoneFab onClick={toggleDrawer} />
            } */}
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
